import * as React from "react";
import { gql, useMutation, ApolloError, MutationHookOptions } from "@apollo/client";
import {
  ResendOtpAdminMutationMutation,
  ResendOtpAdminMutationMutationVariables
} from "../../../../schemaTypes";

export const resendOtpAdminMutation = gql`
  mutation ResendOtpAdminMutation(
    $email: String!
  ) {
    resendOtpAdmin(
      email: $email
    ){
      errors{
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      resendOtpAdmin: (
        values: ResendOtpAdminMutationMutationVariables
      ) => Promise<ResendOtpAdminMutationMutation["resendOtpAdmin"] | null>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
  options?: MutationHookOptions<ResendOtpAdminMutationMutation, ResendOtpAdminMutationMutationVariables>;
}

export const ResendOtpAdminController: React.FC<Props> = ({ children, options }) => {
  const [mutate, { loading, error }] = useMutation<
    ResendOtpAdminMutationMutation,
    ResendOtpAdminMutationMutationVariables
  >(resendOtpAdminMutation, options);

  const resendOtpAdmin = async (values: ResendOtpAdminMutationMutationVariables) => {
    try {
      const result = await mutate({ variables: values });
      return result.data?.resendOtpAdmin ?? null;
    } catch {
      return null;
    }
  };

  return children({ resendOtpAdmin, loading, error });
};